export const DAI_START = 'daistart';
export const DAI_END = 'daiend';
export const DAI_AD_TYPE = 'INSTREAM';
export const DAI_CLICKTHROUGH = 'clickThrough';

export const DAI_IN = 'daiIn';
export const DAI_OUT = 'daiOut';
